export default {
  name: "ConfirmMessageDlg",
  data() {
    return {
      dialog: false,
      reject: null,
      message: null,
      outputMsg: "",
      title: null,
      resolve: null,
      hasTextField: false,
      textFieldLabel: "Note",
      isAgree: false,
      isSuccess: false,
      thanksMessage: "",
      errorMessage: "",
      loadingMessage: "",
      loading: false,
      options: {
        color: "#3f51b5",
        width: 605,
        zIndex: 200,
        noconfirm: false
      }
    }
  },
  methods: {
    open(title, message, hasTextField, textFieldLabel, options, thanksMessage, errorMessage, loadingMessage) {
      this.dialog = true;
      this.title = title;
      this.hasTextField = hasTextField;
      this.textFieldLabel = textFieldLabel;
      this.message = message;
      this.thanksMessage = thanksMessage;
      this.errorMessage = errorMessage;
      this.loadingMessage = loadingMessage;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.isAgree = true;
      this.isSuccess = true;
      this.resolve({ agree: true, message: this.outputMsg });
    },

    error() {
      this.isSuccess = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
      this.isAgree = false;
    },

    load() {
      this.loading = true;
    },
  }
}